import { render, staticRenderFns } from "./BusinessScopeSearch.vue?vue&type=template&id=64888b0d&"
import script from "./BusinessScopeSearch.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports